import { IconButton, Typography } from "@mui/material"
import { CarModelSafetySystemItemDto } from "api"
import TruncateText from "common/bit/TruncateText"
import dynamic from "next/dynamic"
import { useEffect, useRef, useState } from "react"
import VideoPlayIcon from "reusable/icons/VideoPlayIcon"
import VideoStopIcon from "reusable/icons/VideoStopIcon"
import styled from "styled-components"

const VideoPlayer = dynamic(() => import("common/VideoPlayer"), {
  loading: () => <p>...</p>,
})
const StyledCardWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: ${(p) => p.theme.colors.lightGrey};
`
const StyledVideoWrapper = styled.div<{ $height: string }>`
  height: ${(p) => p.$height};
  width: 100%;
  position: absolute;
  /* position: relative; */
  overflow: hidden;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  margin: 0px auto;
  video {
    clip-path: inset(1px 1px);
  }
`
const StyledIconButton = styled(IconButton)`
  width: 80px;
`
const StyledTitle = styled(Typography)`
  text-align: center;
  width: 250px;
`
const StyledTruncateWrapper = styled.div`
  height: 135px;
  width: 250px;
`
const StyledTruncateText = styled(TruncateText)`
  text-align: center;
  font-size: 16px;
  color: ${(p) => p.theme.colors.disable};
`
const StyledBoxZIndex = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  width: 100%;
  margin: 0px auto;
  & > * {
    z-index: 120;
  }
`
const StyledPlayRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const StyledGradientOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    #f5f5f5 0%,
    rgba(245, 245, 245, 0) 23.77%,
    rgba(245, 245, 245, 0) 44.21%,
    #f5f5f5 77.43%
  );
`
type SafetyVideoProps = {
  height?: string
  item: CarModelSafetySystemItemDto
  isActive: boolean
  isNext: boolean
}

const SafetyVideoCard = ({
  item,
  height = "100%",
  isActive,
  isNext,
}: SafetyVideoProps) => {
  const [playing, setPlaying] = useState(isActive)
  const videoRef = useRef(null)

  useEffect(() => {
    setPlaying(isActive)
  }, [isActive])

  return (
    <StyledCardWrapper className={isNext ? "active-safe" : undefined}>
      <StyledVideoWrapper $height={height} ref={videoRef}>
        {(isNext || isActive) && (
          <VideoPlayer
            url={isNext || isActive ? item?.video?.imageUrl : ""}
            light={false}
            label={item.video.alt}
            playingState={playing}
            loop={true}
            imgAlt={item.video.alt}
            imgUrlDesktop={"/placeholder.jpeg"}
            imgUrlMobile={"/placeholder.jpeg"}
            cover={false}
          />
        )}
        <StyledGradientOverlay />
      </StyledVideoWrapper>
      {/* add Gradient overly */}
      <StyledBoxZIndex>
        <StyledPlayRow>
          {playing ? (
            <StyledIconButton
              onClick={() => {
                setPlaying(false)
              }}
            >
              <VideoStopIcon />
            </StyledIconButton>
          ) : (
            <StyledIconButton
              onClick={() => {
                setPlaying(true)
              }}
            >
              <VideoPlayIcon />
            </StyledIconButton>
          )}
        </StyledPlayRow>
        <StyledTitle variant="h3">{item?.shortName}</StyledTitle>
        {/* todo replace to short description*/}
        <StyledTruncateWrapper>
          <StyledTruncateText
            line={2}
            element="span"
            truncateText="…"
            text={item?.description}
          />
        </StyledTruncateWrapper>
      </StyledBoxZIndex>
    </StyledCardWrapper>
  )
}

export default SafetyVideoCard
